import React from "react";

import type { BoxProps } from "@/ui/atoms/Box";
import Box from "@/ui/atoms/Box";

import LayoutFillParentOverlay from "@/ui/layouts/LayoutFillParentOverlay";

export type LayoutFullScreenOverlayProps = BoxProps & {
    opacity?: number;
    backgroundColor?: string;
};

const testId = "LayoutFullScreenOverlay";
const LayoutFullScreenOverlay: React.FC<LayoutFullScreenOverlayProps> = ({
    children,
    opacity = 0.65,
    backgroundColor = "var(--proda-white-110)",
    sx,
    ...otherProps
}) => {
    return (
        <Box
            data-testid={testId}
            className={testId}
            sx={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                zIndex: 9999,
                ...sx,
            }}
            {...otherProps}
        >
            <LayoutFillParentOverlay
                backgroundColor={backgroundColor}
                opacity={opacity}
            >
                {children}
            </LayoutFillParentOverlay>
        </Box>
    );
};

export default LayoutFullScreenOverlay;
